class cApi {
  
  /*console.log(zfill(324, 2)); // 324
  console.log(zfill(324, 3)); // 324
  console.log(zfill(324, 4)); // 0324
  console.log(zfill(324, 5)); // 00324
  console.log(zfill(324, 10)); // 0000000324
  console.log(zfill(-324, 5)); // -0324
  */
  static zeroFill( number, width )
  {
    width -= number.toString().length;
    if ( width > 0 )
    {
      return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
    }
    return number + ""; // siempre devuelve tipo cadena
  }

  // genera una cadena aleatorio de 3 letras
  //console.log(generarAleatorios(5));
  //console.log(generarAleatorios(8));
  //console.log(generarAleatorios(62));

  static generarCadAleatoria(cantidad) {
    const caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split("");
    cApi.barajar(caracteres);
    return caracteres.slice(0,cantidad).join("")
  }
  //---------------mezcla un array
  static barajar(array) {
    let posicionActual = array.length;
  
    while (0 !== posicionActual) {
      const posicionAleatoria = Math.floor(Math.random() * posicionActual);
      posicionActual--;
      //"truco" para intercambiar los valores sin necesidad de una variable auxiliar
      [array[posicionActual], array[posicionAleatoria]] = [
        array[posicionAleatoria], array[posicionActual]];
    }
    return array;
  }
  /******************************* */
  /* encript, decript */
  static encrypt(text, key){
    return [...text].map((x, i) => 
    (x.codePointAt() ^ key.charCodeAt(i % key.length) % 255)
     .toString(16)
     .padStart(2,"0")
   ).join('')
  }
  static decrypt(text, key){
      return String.fromCharCode(...text.match(/.{1,2}/g)
      .map((e,i) => 
        parseInt(e, 16) ^ key.charCodeAt(i % key.length) % 255)
      )
  }
  /*let enc = encrypt("My String", "Passphrase")
  let dec = decrypt(enc, "Passphrase")

  console.log(enc) // 1d185320041a1b0f14
  console.log(dec) // My String
  */
 /******************************* */
}

export default cApi;